export enum DocumentsBreadcrumbActionTypes {
  ADD_BREADCRUMB_ITEM = 'ADD_BREADCRUMB_ITEM',
  SET_BREADCRUMB_ITEMS = 'SET_BREADCRUMB_ITEMS',
  GOTO = 'GOTO',
  RESET_BREADCRUMB = 'RESET_BREADCRUMB',
}
